// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1__bk","cls2":"PaperAbstract-cls2_eUL PaperAbstract-cls1__bk","variant-dense":"PaperAbstract-variant-dense_W8i"};